// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1Jfjz","actions":"GroupTable_actions__1SYWF","deleteModalFooter":"GroupTable_deleteModalFooter__-vlgT"};